import agbIcon from 'assets/images/logo-btext.svg';

export default {
  icon: agbIcon,
  primaryColor: '#1e2d54',
  welcomeLogoWallet: '',
  welcomeMessage: 'Welcome to AGB',
};
